import { Module } from 'vuex'
import { FeedbackState } from '../types/FeedbackState'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'
import { state } from './state'

export const module: Module<FeedbackState, any> = {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
}
